<template>
  <base-button
    :disabled="disabled"
    :loading="loading"
    :type="type"
    :icon="icon"
    :icon-only="iconOnly"
    :caption="caption"
    :svg-icon="svgIcon"
    :tooltip="tooltip"
    @click="handleClick"
  />
</template>

<script>
import BaseButton from '@/components/crud/BaseButton';
export default {
  components: {
    BaseButton
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    buttonIcon: {
      type: String,
      default: null
    },
    iconOnly: {
      type: Boolean,
      default: true
    },
    action: {
      type: String,
      default: '',
      validator: function(value) {
        // The value must match one of these strings
        return (
          [
            'add',
            'save',
            'cancel',
            'saveClose',
            'saveNext',
            'delete',
            'copy',
            'clearFilters',
            'primary',
            'secondary'
          ].indexOf(value) !== -1
        );
      }
    },
    buttonTranslation: {
      type: String,
      default: null
    },
    buttonString: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    type() {
      switch (this.action) {
        case 'add':
        case 'save':
        case 'saveClose':
        case 'saveNext':
        case 'copy':
        case 'primary':
          return 'primary';
        default:
          return '';
      }
    },
    icon() {
      if (this.buttonIcon) {
        return this.buttonIcon;
      } else {
        switch (this.action) {
          case 'add':
            return 'el-icon-circle-plus';
          case 'cancel':
            return 'el-icon-close';
          case 'delete':
            return 'el-icon-delete';
          case 'copy':
            return 'el-icon-copy-document';
          default:
            return '';
        }
      }
    },
    caption() {
      if (this.buttonTranslation) {
        return this.$i18n.t(this.buttonTranslation);
      } else if (this.buttonString) {
        return this.buttonString;
      } else if (this.action !== 'primary') {
        return this.$i18n.t('common.' + this.action);
      } else {
        return '';
      }
    },
    svgIcon() {
      if (this.loading) {
        return '';
      }
      switch (this.action) {
        case 'save':
          return 'save';
        case 'saveClose':
          return 'saveclose';
        case 'saveNext':
          return 'savenext';
        case 'clearFilters':
          return 'clearFilters';
        default:
          return '';
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-navbar button {
  &.icon-only {
    font-size: 19px;
  }
  .svg-container {
    margin-right: 5px;
  }
}
@media only screen and (max-width: 767px) {
  .sub-navbar button {
    .svg-container {
      margin-left: 0px;
    }
  }
}
</style>
